import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { IManagementAction } from '../IManagementAction';

export const putManagment = createAction(
  '[TimeCard/API] Update Time Entry Status',
  props<{ managementAction: IManagementAction }>()
);

////////////////////////////////////////////////////////////////

export const loadManagementActions = createAction(
  '[ManagementAction/API] Load ManagementActions',
  props<{ managementActions: IManagementAction[] }>()
);

export const addManagementAction = createAction(
  '[ManagementAction/API] Add ManagementAction',
  props<{ managementAction: IManagementAction }>()
);

export const upsertManagementAction = createAction(
  '[ManagementAction/API] Upsert ManagementAction',
  props<{ managementAction: IManagementAction }>()
);

export const addManagementActions = createAction(
  '[ManagementAction/API] Add ManagementActions',
  props<{ managementActions: IManagementAction[] }>()
);

export const upsertManagementActions = createAction(
  '[ManagementAction/API] Upsert ManagementActions',
  props<{ managementActions: IManagementAction[] }>()
);

export const updateManagementAction = createAction(
  '[ManagementAction/API] Update ManagementAction',
  props<{ managementAction: Update<IManagementAction> }>()
);

export const updateManagementActions = createAction(
  '[ManagementAction/API] Update ManagementActions',
  props<{ managementActions: Update<IManagementAction>[] }>()
);

export const deleteManagementAction = createAction(
  '[ManagementAction/API] Delete ManagementAction',
  props<{ id: string }>()
);

export const deleteManagementActions = createAction(
  '[ManagementAction/API] Delete ManagementActions',
  props<{ ids: string[] }>()
);

export const clearManagementActions = createAction(
  '[ManagementAction/API] Clear ManagementActions'
);
